import { jsx, Fragment } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import TableHeaderRow from './HeaderRow/TableHeaderRow.js';
import TableHeaderCell from './HeaderCell/TableHeaderCell.js';
import 'date-fns/format';
import event from '../../utils/events.js';
import { SCROLLBAR_WIDTH } from '../constants.js';
import { gridHorizontalScrollEvent } from './scrollUtils.js';

const scrollHandler = (e) => {
    var _a;
    event.emit(gridHorizontalScrollEvent, ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.scrollLeft) || 0, 'header');
};
const TableHeader = ({ headerGroups, rtl, headerHeight, width, columnResizingShift, onColumnDrop, enableColumnDragging, disableRowFiltering, disableSortBy, disabled, disableResizing, headerCellPadding, columnOrder, }) => {
    const [scrollLeft, setScrollLeft] = useState(0);
    useEffect(() => {
        event.on('TableHeader', gridHorizontalScrollEvent, (scrollLeft, origin) => {
            if (origin === 'header')
                return;
            return setScrollLeft(scrollLeft);
        });
        return () => {
            event.off('TableHeader', gridHorizontalScrollEvent);
        };
    }, []);
    return (jsx(Fragment, { children: headerGroups.map(headerGroup => (jsx(TableHeaderRow, Object.assign({ rtl: rtl }, headerGroup.getHeaderGroupProps(), { onScrollCapture: scrollHandler, height: headerHeight, width: width, scrollbarWidth: SCROLLBAR_WIDTH, columnResizingShift: columnResizingShift, scrollLeft: scrollLeft }, { children: headerGroup.headers.map(column => {
                if (column.id === 'row-menu-column') {
                    return null;
                }
                return (jsx(TableHeaderCell, Object.assign({ rtl: rtl, column: column, "data-testid": `${column.id}-column`, onColumnDrop: onColumnDrop, enableColumnDragging: enableColumnDragging, disableRowFiltering: disableRowFiltering, disableSortBy: disableSortBy, disabled: disabled, disableResizing: disableResizing, headerCellPadding: headerCellPadding, columnOrder: columnOrder }, { children: column.render('Header') }), column.id));
            }) })))) }));
};
TableHeader.displayName = 'TableHeader';

export { TableHeader as default };
//# sourceMappingURL=TableHeader.js.map
